<script>
import { mapState } from "vuex";
import openlayerMap from "./openlayer_ol";

export default {
  name: "vuelayers",
  data() {
    return {
      clock: null,
      isClockShow: true,
      viewOption: {
        projection: "EPSG:4326",
        rotation: 2.35,
        center: [121.757367, 24.724929],
        zoom: 18,
        minZoom: 18,
        maxZoom: 20,
        extent: [121.753223, 24.722324, 121.761109, 24.72734], //[minx, miny, maxx, maxy]
      },
      markers: [
        {
          geometry: [121.757599, 24.724648],
          parameter: {
            name: "aPlanet",
          },
          iconUrl: require("../../assets/images/A.png"),
          iconAnchor: [48, 52],
          feature: null,
          containerId: null,
        },
        {
          geometry: [121.756794, 24.724946],
          parameter: {
            name: "bPlanet",
          },
          iconUrl: require("../../assets/images/B.png"),
          iconAnchor: [48, 52],
          feature: null,
          containerId: null,
        },
        {
          geometry: [121.756649, 24.724303],
          parameter: {
            name: "cPlanet",
          },
          iconUrl: require("../../assets/images/C.png"),
          iconAnchor: [48, 52],
          feature: null,
          containerId: null,
        },
        {
          geometry: [121.75734, 24.725448],
          parameter: {
            name: "spaceP",
          },
          iconUrl: require("../../assets/images/P.png"),
          iconAnchor: [48, 52],
          feature: null,
          containerId: null,
        },
      ],
      spaceGeo: [121.75554, 24.72285, 121.7595, 24.7269],
      starwayGeo: [121.754285, 24.721689, 121.759705, 24.72718],
      spaceMap: null,
      spaceMapView: null,
      spaceMapVectorSource: null,
      spaceMapImageLayer: null,
      currentDialog: "",
      currentPIcon: null,
      textCount: 0,
      msgs: [],
      showMsg: true,
      currentSec: "",
      currentSecMsg: "",
      yactiveName: "",
      gactiveName: "",
      bactiveName: "",
      pactiveName: "",
      aPlanetData: [
        {
          title: "PLANET TOUCH ",
          label: "人文星球",
          content:
            "回想兒時的我們，有夢想、敢冒險、天馬行空，時刻帶著好奇心迫不及待想探索生命中的種種。以人文星球為起始，在有高有低的生命旅程中與每個人互動交流，透過一連串的感官體驗掀起觸動人心的情緒表達，啟動探索宇宙的好奇心，在彼此互動體驗的過程中，不論語言、地點、年紀、性別，漸漸拉近人與人之間的距離，感受過程中的溫暖心弦。",
        },
        {
          title: "HUMILITY VILLAGE",
          label: "人文聚落帳篷",
          content: `近年自歐美漸漸蔓延到台灣的戶外生活文化熱潮，已形成勢不可擋的lifestyle趨勢。#日赤設計 以空間規劃起家，透過專業經驗，結合露營、活動與展覽策劃，創造戶外休閒運動多元的體驗、開拓富足的生活視野。此次登陸德築宇宙園區，在人文星球以七頂六芒星天幕打造星球活動領域，不論是地球人、太空使者、舞者、創作者，每一個人都能擁有溫暖愉悅的交流空間。\n\n<a href="https://www.instagram.com/enjoyplaywild/?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "SPACE BASKETBALL",
          label: "太空花式籃球",
          content: `球魁陳勇勝領軍的花式籃球表演團體BallerTime Lab，這次有家長代表的周大哥、大學新鮮人阿倫、高中模範生阿江，以及超級帥氣可愛的心樂一同登陸人文星球與大家用籃球創作表演進行交流。透過手上的籃球，表演者結合音樂所呈現的藝術創作，不需要投籃也不需要防守，只需要手上一顆球，就能傳遞籃球快樂心弦的語言，帶給大家最純正血統的花式籃球，遨遊宇宙都能玩出獨創自我的Freestyle！\n\n<a href="https://www.instagram.com/chiukui_official/?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "SPACE DJ",
          label: "太空DJ使者",
          content: `DJ Chicano aka. 光頭哥是台灣Hip hop文化先驅者之一，28年來以音樂傳承文化思維，於2010年創辦 #節拍廣場 推廣活動，每個月在台北市電影主題公園呈現HipHop文化最原始的樣貌，持續推動台灣次文化的交流與發展。首次登陸德築宇宙，將主導人文星球與科技星球的音樂節奏創作，帶來溫暖心弦的音樂旋律，並啟動首航科技感和熱力十足的希望節奏，與現場地球人及太空使者群一起航向想去的世界。\n\n<a href="https://www.instagram.com/beatsquarehavinfun?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "MOONWALK BAR",
          label: "太空漫步酒吧",
          content: `沒有什麼比喝完直接上樓睡覺更讓人舒爽的事了，位在宜蘭市的「Coming Home Bar 」結合住宿與酒吧，讓旅人能不受拘束的享受一切。隨時隨地20分鐘的車程可以去山裡沉靜、去海邊放鬆心靈，主題調酒客製化服務，伴隨你的心情，為旅程帶來新的體悟。等待夜幕降臨時，來一杯奇幻的迷霧星空調酒，結合星球感的煙燻泡泡，每個人手上的那杯太空調酒，都是驚喜。\n\n<a href="https://www.facebook.com/cominghomebar/?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "SPACE STRAIGHTUP",
          label: "太空攝影使者",
          content: `#質上 由一群對視覺影像及訴說故事有高度熱忱的年輕創作者組成團隊，以「Create a better vision」為理念，為每部影音創作切入與眾不同的視角，打造有故事、有內容的視覺創意，製作德築宇宙首航動畫之餘，更將一起登陸德築宇宙園區，紀錄地球人探索主題星球的軌跡，致力帶來美麗和激勵人心的影視體驗。\n\n<a href="https://www.straightupco.tv/?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "UNIVERSE ATTRACTION",
          label: "宇宙空投打卡站",
          content: `繁星閃爍點綴星空，德築宇宙的 #恆星鐵桶 有機排序的座落在人文星球之中，以活力帶給人愉悅心情的黃色，將一桶桶閃亮的恆星鐵桶點亮德築宇宙園區。人文星球的六芒星天幕可找到其身影，方便圍繞交流、置放星光杯和太空美食之外，更是小孩東奔西藏的趣味領域。太空DJ使者前方區域更擁有宇宙拍攝絕佳位置的空投打卡點，歡迎和你愛及愛你的人，一同到這裡留下星球軌跡。\n\n<a href="https://www.artai.com.tw/?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "SPACE DINING",
          label: "太空料理站",
          content: `小豆田茶餐室來自地球上美麗的宜蘭，秉持自然、健康、環保的品牌精神，堅持以無肉料理的理念，從天然原形食材出發，為每一位品嚐餐點的顧客創作溫暖的料理，啟發想像。以日式療癒蔬食為根基，小豆田將洋食、甜點、咖啡組合出融入宇宙意象的星球甜食、太空鹹食等餐點，為德築宇宙首航派對創作了有別以往的全新飲食體驗。\n\n<a href="https://www.facebook.com/DOMOTAIWAN/?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "SPACE BEER",
          label: "太空啤酒",
          content: `擁有宜蘭在地純樸與人情味的麥田現釀啤酒團隊，不添加大米或玉米等穀物，保留啤酒中的酵母活菌等營養，以宜蘭純淨好水為助力，堅持釀造濃郁的麥香啤酒。品飲一口，你就能感受香醇麥香與綿密的口感，不論你是地球人、太空使者還是外星人，喝上一口就能悠遊於宇宙，身心靈暢快沁涼，享受微醺。\n＊太空使者叮嚀：未滿18歲請勿飲酒，禁止酒駕\n\n<a href="https://www.facebook.com/YiLanbeer/?locale=zh_TW&openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "FUN SLIME DIY",
          label: "太空史萊姆DIY",
          content: `#PILALA 世界由五大元素勇氣、冒險、自信、創意、活潑所組成，創立的初衷希望在PILALA 世界裡的每個大小朋友，都能展現內心最率真的樣貌、發展自己獨一無二的可愛、發揮天馬行空的創造力。一起在德築宇宙首航派對喊出「PILALA」，進入PILALA的快樂世界，拋開地球的忙碌，喚醒內心深處最快樂的純粹。\n\n德築宇宙首航更釋出專屬小朋友的太空臉部彩繪，限量50位名額，快帶孩子們來試試地球人變身小小外星人，展現獨一無二的可愛魅力。\n\n<a href="https://www.pilalapark.com/?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "SPACEMAN EGG CAKE",
          label: "太空人雞蛋糕",
          content: `在世界走了一圈回到台灣創立 #外星人也小行星 雞蛋糕的小老闆，就像外星人一樣，只想創造自己熱愛的生活並活出自我。每次想起童年巷口都會飄香的雞蛋糕，在當前充滿人工添加物食品的世界，他下定決心要研發出無添加物的雞蛋糕，並藉由各種太空造型的雞蛋糕創作，邀請更多人在品嚐綿綿蛋香美味時，還能自由想像徜徉宇宙之間的樂趣，在星球間探險跟挖掘有趣的記憶。\n\n<a href="https://www.facebook.com/ETeggcakeplanet/?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "MARSHMALLOW FANTACY",
          label: "迷幻銀河棉花糖",
          content:
            "如果棉花糖是幸福、製造歡樂的催化劑，那麼 #花現愛創意棉花糖 便是最能感受這份幸福歡樂的所在。秉持美味、健康、天然、創意的四大理念，以一股傻勁，將有如星球的圓形棉花糖點綴在銀河裡，每咬一口都能看見屬於自己的閃耀光芒，陪伴大家前往未知探險，一起進入迷幻的宇宙世界。",
        },
        {
          title: "GALAXY ICE CREAM",
          label: "銀河霜淇淋",
          content: `童年記憶裡霜淇淋的味道，有夏日午後一定要吃的果汁牛奶口味，也有初戀青澀感的酸甜草莓口味。#大仙霜淇淋 提供設計、設備、原物料等全方位霜淇淋服務，為每一個歡聚時光增添豐富的清爽氣息。此次登陸德築宇宙園區，獨創設計推出太空霜淇淋，以芝麻、香草佐芒果醬的銀河感，讓與會者享受降落宇宙的全新味蕾體驗。\n\n<a href="https://dasianicecream.com/?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "SOIL CHURROS",
          label: "土壤吉拿棒",
          content: `宜蘭夜市熱門點心 #就一口吉拿棒，是一對小情侶將陪伴彼此時，忍不住分享手中美食給對方的幸福感，變身點心的創作。生活裡藏著相愛的蹤跡，有苦有甜，融入吉拿棒的每一種口味，在宇宙中調配出最耐人咀嚼的口感與味蕾，摘下銀河裡的星星、挖掘星球上的可食土壤，研發出宇宙中回味無窮的土壤吉拿棒。\n\n<a href="https://www.facebook.com/yiko.churros?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "SPACE MAGICIAN",
          label: "星際魔術師",
          content: `魔術師#徐開炫 是台灣街頭藝術文化推廣的領銜者之一，擅長研究與觀眾一同遊戲的創作，利用馬戲技巧結合心理學與聲音科技，引領觀眾進入遊戲空間的心流。魔術師為首航派對全新設計有別以往的互動表演，呼應人文星球主題，要帶給地球人感受人文交流那份驚喜與溫暖，一起讓更多美好的事情留下軌跡在宇宙時空。\n\n德築宇宙首航更釋出專屬小朋友的太空臉部彩繪，限量50位名額，快帶孩子們來試試地球人變身小小外星人，展現獨一無二的可愛魅力。\n\n<a href="https://www.instagram.com/mario_hsu_tw/?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
      ],
      bPlanetData: [
        {
          title: "PLANET PLANT",
          label: "自然星球",
          content:
            "宇宙中萬物的起源與仰賴的根基便是自然生態。自然星球孕育著德築宇宙存在的意義，每一株植物和人一樣都是獨一無二的生命，而每一個在這裡探索的地球人，要帶著勇氣與無畏的冒險精神，努力與周遭環境平衡共存，將心中原有的既定框架打破、發掘更好的自己。生命旅程經歷一次次起伏，就好似一次次走進未知的水域，每一次的忐忑在經歷沈澱都在幫助我們強化心志和轉變心境，每個人都可持續探索內心的聲音，將生命的體驗昇華，並在宇宙循環之中找到昂首闊步的生命張力，找到心中對未來的嚮往。",
        },
        {
          title: "PLANT YOUR ADVENTURE",
          label: "探險未知",
          content:
            "人與周遭環境的平衡共存，是一場必要的冒險。未來的世界自然資源並非唾手可得，而是需要擁有奮力追尋的冒險精神、以及解構再造的創造力讓生命得以延續。\n\n星際探索是人類探索未知的極限，在超越極限的環境中，我們充滿勇氣與創意。在前導「STAR SINGER  星際吟詩者」登高吟唱招喚之下，「GALAXY WALKER 星際探險家」在「DEZU MIRROR德築之鏡」粼粼水光的藍色三角之中探險拓荒，冒險的氣息吸引著彼此與其更加靠近，一場場生存搏鬥之後，發現屬於徳築宇宙獨一無二的神秘力量，並分享生命之水給身邊人，天際印暉著彩霞，整個場域漫溢著生命張力，一同進入自然星球的奇幻世界，向宇宙致敬永恆。",
        },
        {
          title: "ECO-GALAXY",
          label: " 宇宙循環生態群",
          content: `自然星球上透過能量的解構與重組，大地的一切化成礫土丘、植物、水三大元素，就像地球一樣形成獨一無二的自然生態。在這裡生長而成的每一株植物都具獨立意識，分別帶著「平靜（彩虹千年木）」、「幸運（積水鳳梨）」、「力量（風雨蘭）」、「活力四射（彩色辣椒）」與「精彩耀眼（五彩蘇/彩葉草）」五種來自德築宇宙的神秘力量。您將受到其中一種植物的神秘召喚、進而讓他成為您這趟旅途中的宇宙小夥伴。\n\n#棚屋 台灣新興崛起的自然景觀創意團隊，獨具國際觀與自然對話的能力，擅長運用綠植的生長姿態的特性與空間陳列的環境，妝點美麗空間享受綠植的生活，打造更多綠植進入質感生活，首次為自然星球設計冒險氛圍，創造有如外太空奇特的旱地感，透過特殊塗料與植栽長相，在交錯的沙丘上打造對宇宙的想像。\n\n<a href="https://www.instagram.com/hallohutte/?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "STAR SINGER",
          label: "星際吟詩者",
          content: `在自然星球駐守的星際吟詩者，擁有穿透人心的歌聲，在魔幻天色前引吭高歌，帶來如夢似幻令人屏息的時刻。吟詩者唱出我們內心對生命冒險的渴望，點燃心中的光，喚醒自我認知，勇敢踏上探索未知與突破極限的旅程。\n\n<a href="http://anarchydancetheatre.com/?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "GALAXY WALKERS",
          label: "星際探險家",
          content: `踏著宇宙間星彩而來的星際探險家，眉間色彩一如星宇光彩。象徵著我們心中那一抹冒險精神、無所畏懼。帶領著我們從自然星球出發，展開一段內心前往冒險的旅程。進入奇幻之地探索，心境不斷隨著天光變幻轉換，有光就也有沈靜面臨低谷的時刻，而探星際險家們無畏懼的在未知水域中搏鬥，接著遞出生命之水給予身邊人，將內化後的力量傳遞出去，一起迎向嶄新且前所未見的希望之地。\n\n#安娜琪舞蹈劇場 藉由當代舞蹈創作思考人與人之間的關係連結，以肢體覺察時間、空間、物體、人與社會之間的關係，突破空間的限制，融合勇氣與創意，登陸德築宇宙創作星際探索之舞，透過登高引吭招喚探索者，一起突破地球人的極限，在自然星球探險拓荒，並發現宇宙的神秘力量，跟著天際的彩霞進入迷茫的魔幻時刻。\n\n<a href="http://anarchydancetheatre.com/?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "REBORN CUBE",
          label: "循環再造工務所",
          content:
            "廢棄的定義是什麼？難道人或物只能有一種身份嗎？「REBORN CUBE 循環再造工務所」是徳築宇宙園區反映大地的鏡面貨櫃，透過金屬資源重新轉換成「REBORN CUBE 循環再造工務所」，象徵著自然星球的「再造意識」，將物體媒介在宇宙循環之中找到新的存在意義，打破既定印象、透過創意展現出全新樣貌以及新身份。我們生活的環境都能透過探索、體驗與實踐，成就循環使用與環境共生的徳築宇宙觀。",
        },
        {
          title: "DEZU MIRROR",
          label: "德築之鏡",
          content:
            "自然星球中要有氧氣流動，最不可或缺的主體便是「水」，在星球中心蓄滿能量的三角水池「DEZU MIRROR 德築之鏡」，是天、地、倒影三點連成一面的能量聚集中心，從太空俯望，指向德築宇宙太空站，孕育形塑出星球上的生態，象徵著生命的起源，更反映出我們內心的世界。",
        },
        {
          title: "WATER ATTRACTION",
          label: "宇宙水池打卡站",
          content:
            "粼粼水天一色的德築之鏡鼓勵地球人在這裡拋開自我勇於探索未知，跟著太空使者群的太空漫步，進入絕佳拍攝降落點，在天光彩霞的印襯與水光反射，留下漂浮於地面之上，虛實又魔幻的快門軌跡。",
        },
        {
          title: "SPACE BAT PLANET",
          label: "攝影使者",
          content: `#徠漫影像 #蝙蝠星球 感性與溫度兼具的國際攝影團隊，在世界各個不同的城市及台灣地區拍攝，透過對影像的熱忱、細膩的情感捕捉，將最好的服務帶給所有生命，讓藝術走近生活中，此次登陸德築宇宙，為與會者補捉在三大主題星球探索遨遊的美麗時光！\n\n<a href="https://linktr.ee/Leiman_image?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
      ],
      cPlanetData: [
        {
          title: "PLANET HUB",
          label: "科技星球",
          content:
            "追逐夢想與成長的過程，需要擁抱希望。科技星球是德築宇宙的信仰中心，是德築集團累積逾十年的創作能量跨進太空引力的建築空間，空間是SPACE，而SPACE也是太空，當我們升級視角和思想，勇於航向宇宙，想像到外太空回看這世界，生活的所見所聞和所想將留下更迷人的空間尺度，繼而發現生命有無限可能。當我們在生命旅程中找到與自己志同道合的築夢者一起前進，內心就會有源源不絕的希望和能量釋放，在浩瀚無垠的宇宙中留下美麗的生命軌跡，每一顆星都會迎來閃閃發光的時刻。",
        },
        {
          title: "HUB TOWARD HOPE",
          label: "航向宇宙",
          content:
            "生命的旅程始於人與人交流，接著有如登陸自然星球時，內心開始對於冒險與自我探索有所渴望，我們都在這旅程中開始找到自我以及對未來的期待。 來到德築宇宙的信仰中心「HUB科技星球」，你將和你愛及愛你的人，巧遇來自光年之外遠道而來、身著星際銀色太空裝的太空築夢者們，用音樂與舞蹈創作點燃人類獨一無二的心中渴望，展開一場對未來的無限想像。歡慶德築宇宙首航就像釋放身心靈的能量與決心，一起成為擁抱希望的宣揚者，在浩瀚無垠的宇宙中留下美麗的生命軌跡，成為一顆顆閃耀的星星！",
        },
        {
          title: "SPACE  DREAMERS",
          label: "太空築夢者",
          content:
            "身著銀色太空裝的太空築夢者來自光年之外的星球，他們擁抱夢想乘著火箭來到徳築宇宙，帶著「擁抱希望」的宇宙訊息而來，受到德築宇宙觀「航向你想去的世界」影響，成為徳築宇宙的擁護者，與自己所愛的人在此佇足，過著自己心中的理想生活。\n\n太空築夢者的召集使者是Dimple小慧老師，近年致力到地球推廣兒童、青少年的街舞發展，深信人人都可以是舞者，享受從舞蹈創作當中帶來的生活樂趣。在科技星球與世界頂尖的Popping Dancers和Breaking Dancers，截然不同的街舞風格，透過舞者們肢體的極限帶來意想不到的表演火花，搭載讓人內心澎湃興奮的節奏，就像在浩瀚的宇宙裡，一切都是充滿未知與希望。",
        },
        {
          title: "HOPE STAGE",
          label: "希望舞台",
          content: `德築以此處為圓心，打造一座讓各界築夢者能共同交流和激發創作魂的生活場域—德築宇宙園區，在宇宙旅程中，感受藝術、設計、運動、音樂等文化交流創造的宇宙軌跡，啟發自我內心深處對未來的想像，帶著希望和德築一起前進。\n\n宇宙星球的自然環境能因我們的保護和照顧而生生不息。台灣獨特塑木研發團隊 #境東綠建材 投身於永續建材設計開發、木作工程、兒童遊具行列，為國際永續及減碳趨勢提供建築材料解決方案，打造舒適的戶外使用空間、堅固耐候耐用的材料打造美麗安全的遊憩環境，採用塑木減少世界樹木的砍伐，德築宇宙未來總部的一樓地坪與屋頂也將採用塑木打造而成，每個人都能為自然環境盡一份心力。當我們首航登陸科技星球，率先體驗100平方公尺由塑木打造而成的希望舞台，為太空築夢者打造平穩安全的表演場域，融合於星球大地上，不論大人小孩都能安全探索，享受音樂隨之舞動的樂趣。\n\n<a href="https://www.eastvision.com.tw/?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "ROCKET LAUNCH",
          label: "火箭發射",
          content: `由台灣、香港資深動畫師及多媒體工程師組成的好動動畫，旗下技術部門多媒體實驗室，深耕各項技術研發，擁有豐沛3D資源庫與程式技術，致力將數位製作應用推向高峰。藉由好好動畫客製首航派對專屬動畫，搖一搖手機畫面，跟著德築火箭的飛行軌跡，一起航向你想去的世界。\n\n<a href="https://www.activeanimation.studio/?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "SHOOTING STARS",
          label: "歡慶啟航/星空燦爛",
          content:
            "煙火團隊擅長於活動中結合各式特效，其專業電腦控制煙火施放，能隨音樂節奏設計舞台煙火表演，為德築宇宙首航揭開精彩的序幕，在浩瀚的星空中留下璀璨的記憶軌跡。德築宇宙首航派對由煙火團隊帶來璀璨的演出，邀請每個人在燦爛星空的陪伴下，在宇宙的彼端一起航向想去的世界。",
        },
        {
          title: "SPACE THIRTEEN",
          label: "攝影製片使者",
          content: `#13. Thirteen studio 自2010年成立以來，為各國際品牌、頂尖運動員、各界年度盛事提供影像製作及統籌，提供橫跨平面與動態製作的全方位服務，同步經營專業攝影棚租借的服務，於首航派對登陸德築宇宙園區，整合各界頂尖攝影使者影像任務，為地球人與太空使者群的探險軌跡帶來激勵人心的視覺體驗。\n\n<a href="https://www.facebook.com/13ThirteenStudio?locale=zh_TW?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
        {
          title: "SPACE CAPTURE",
          label: "攝影使者",
          content: `在台北艋舺長大的地球人大黑，透過對攝影的熱愛遨遊世界，其平面攝影捕捉的運動畫面、人物、商品寫真、劇照，保留住地球上讓人感動的故事瞬間，在瞬息萬變的運動場上與安靜精密的攝影棚之間切換，對於人物真實情感的瞬間凝結有獨特的視角。此次登陸德築宇宙，將以其鏡頭紀錄地球人前往太空探索跟創造宇宙軌跡的經典時刻。\n\n<a href="https://www.kaochishun.com?openExternalBrowser=1" target="_blank" rel="noopener noreferrer">前往探索</a>`,
        },
      ],
      planetPData: [
        {
          title: "PARKING",
          label: "停機坪",
          content:
            "行駛進入宇宙園區後，請依循太空使者的指引至停車位置。\n園區內停車位額滿時，將引導至園區附近路邊停車。",
        },
      ],
      aPlanetURL: require("../../assets/images/logo_y.png"),
      bPlanetURL: require("../../assets/images/logo_g.png"),
      cPlanetURL: require("../../assets/images/logo_b.png"),
      aPlanetPostURL: require("../../assets/images/vo1_0.png"),
      bPlanetPostURL: require("../../assets/images/vo2_0.png"),
      cPlanetPostURL: require("../../assets/images/vo3_0.png"),
      swiperPicOption: {
        initialSlide: 0,
        autoHeight: true,
        mousewheel: false,
        longSwipes: true,
        shortSwipes: true,
        allowTouchMove: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      planetA: {
        geometry: [121.757684, 24.724165],
        feature: null,
      },
      planetB: {
        geometry: [121.756479, 24.725183],
        feature: null,
      },
      planetC: {
        geometry: [121.75639, 24.724032],
        feature: null,
      },
      timeout: null,
    };
  },
  computed: {
    ...mapState({
      latitude: (state) => state.space.latitude,
      longitude: (state) => state.space.longitude,
      rockettime: (state) => state.space.rockettime,
    }),
  },
  watch: {
    latitude(newV, oldV) {
      if (newV !== oldV) {
        this.resetCurrentGeometry([this.longitude, newV]);
      }
    },
    longitude(newV, oldV) {
      if (newV !== oldV) {
        this.resetCurrentGeometry([newV, this.latitude]);
      }
    },
  },
  created() {
    let aPlanetImg = new Image();
    let bPlanetImg = new Image();
    let cPlanetImg = new Image();
    aPlanetImg.src = this.aPlanetURL;
    bPlanetImg.src = this.bPlanetURL;
    cPlanetImg.src = this.cPlanetURL;
    let aPlanetPost = new Image();
    let bPlanetPost = new Image();
    let cPlanetPost = new Image();
    aPlanetPost.src = this.aPlanetPostURL;
    bPlanetPost.src = this.bPlanetPostURL;
    cPlanetPost.src = this.cPlanetPostURL;
  },
  async mounted() {
    await this.init();
    await this.spaceMap.on("click", (evt) => {
      const feature = this.spaceMap.forEachFeatureAtPixel(
        evt.pixel,
        function (feature) {
          return feature;
        }
      );
      if (feature) {
        let level = feature.get("name");
        switch (level) {
          case "spaceP":
            this.pactiveName = "spaceP_1";
            setTimeout(() => {
              this.currentDialog = "spaceP";
            }, 50);
            break;
          case "aPlanet":
            this.yactiveName = "";
            setTimeout(() => {
              this.currentDialog = "aPlanet";
              if (Number(this.$refs.aPlanetSwiper.$swiper.activeIndex) !== 1) {
                setTimeout(() => {
                  this.$refs.aPlanetSwiper.$swiper.slideTo(1, 500);
                  document
                    .querySelector(".yellow_glow .icon_down")
                    .classList.add("aon");
                }, 1500);
              } else {
                document
                  .querySelector(".yellow_glow .icon_down")
                  .classList.add("aon");
              }
            }, 50);
            break;
          case "bPlanet":
            this.gactiveName = "";
            setTimeout(() => {
              this.currentDialog = "bPlanet";
              if (Number(this.$refs.bPlanetSwiper.$swiper.activeIndex) !== 1) {
                setTimeout(() => {
                  this.$refs.bPlanetSwiper.$swiper.slideTo(1, 500);
                  document
                    .querySelector(".gray_glow .icon_down")
                    .classList.add("aon");
                }, 1500);
              } else {
                document
                  .querySelector(".gray_glow .icon_down")
                  .classList.add("aon");
              }
            }, 50);
            break;
          case "cPlanet":
            this.bactiveName = "";
            setTimeout(() => {
              this.currentDialog = "cPlanet";
              if (Number(this.$refs.cPlanetSwiper.$swiper.activeIndex) !== 1) {
                setTimeout(() => {
                  this.$refs.cPlanetSwiper.$swiper.slideTo(1, 500);
                  document
                    .querySelector(".blue_glow .icon_down")
                    .classList.add("aon");
                }, 1500);
              } else {
                document
                  .querySelector(".blue_glow .icon_down")
                  .classList.add("aon");
              }
            }, 50);
            break;
        }
      }
    });
  },
  beforeDestroy() {
    clearInterval(this.clock);
  },
  methods: {
    async init() {
      //init map
      var { mapView, mapServer } = await openlayerMap.initMap(
        "openlayers",
        this.viewOption
      );
      //add park layer
      var staticImage = await openlayerMap.createStaticImage(
        require("../../assets/images/ALL_.png"),
        this.spaceGeo,
        {
          zIndex: 0,
        }
      );
      const mapImageLayer = await openlayerMap.createImageLayer(staticImage);
      mapServer = await openlayerMap.addImageLayer(mapServer, mapImageLayer);
      //add star layer
      var starImage = await openlayerMap.createStaticImage(
        require("../../assets/images/starway_.png"),
        this.starwayGeo,
        {
          zIndex: 1,
        }
      );
      const starImageLayer = await openlayerMap.createImageLayer(starImage);
      mapServer = await openlayerMap.addImageLayer(mapServer, starImageLayer);
      //add markers
      await this.markers.map(async (e) => {
        e.feature = await openlayerMap.createIconFeature(
          e.geometry,
          e.parameter,
          e.iconUrl,
          e.iconAnchor
        );
        return e;
      });
      const features = await this.markers.map((e) => e.feature).concat();
      const mapVectorSource = await openlayerMap.createVectorLayer(features);
      mapServer = await openlayerMap.addVectorLayer(mapServer, mapVectorSource);

      //current
      this.currentPIcon = await openlayerMap.createPopupOverlay(
        document.querySelector(`#currentPosition`),
        "center-center"
      );
      mapServer = await openlayerMap.addOverlayLayer(
        mapServer,
        this.currentPIcon
      );
      this.currentPIcon.setPosition([this.longitude, this.latitude]);

      // planet people text
      this.planetA.feature = await openlayerMap.createPopupOverlay(
        document.querySelector(`#planetANum`),
        "center-center"
      );
      mapServer = await openlayerMap.addOverlayLayer(
        mapServer,
        this.planetA.feature
      );
      await this.planetA.feature.setPosition(this.planetA.geometry); //A
      this.planetB.feature = await openlayerMap.createPopupOverlay(
        document.querySelector(`#planetBNum`),
        "center-center"
      );
      mapServer = await openlayerMap.addOverlayLayer(
        mapServer,
        this.planetB.feature
      );
      await this.planetB.feature.setPosition(this.planetB.geometry); //B
      this.planetC.feature = await openlayerMap.createPopupOverlay(
        document.querySelector(`#planetCNum`),
        "center-center"
      );
      mapServer = await openlayerMap.addOverlayLayer(
        mapServer,
        this.planetC.feature
      );
      await this.planetC.feature.setPosition(this.planetC.geometry); //C

      this.spaceMap = await mapServer;
      this.spaceMapView = await mapView;
      this.spaceMapVectorSource = await mapVectorSource;
      this.spaceMapImageLayer = await mapImageLayer;
    },
    flyTo(location, zoomOp) {
      openlayerMap.flyTo(this.spaceMapView, location, zoomOp, function () {});
    },
    resetCurrentGeometry(geometry) {
      let isin = this.isPointInPolygon({ lng: geometry[0], lat: geometry[1] }, [
        [121.756622, 24.726006],
        [121.758658, 24.726023],
        [121.758571, 24.723819],
        [121.756265, 24.724167],
      ]);
      if (isin) {
        this.currentPIcon.setPosition(geometry);
      }
    },
    isPointInPolygon(lnglat, polygon) {
      //{lng,lat}, [[lng,lat]]
      var cnt = 0;
      for (var i = 0; i < polygon.length; i++) {
        const g = lnglat.lng;
        const t = lnglat.lat;
        const p1g = polygon[i][0]; //lng
        const p1t = polygon[i][1]; //lat
        const p2g = polygon[i === polygon.length - 1 ? 0 : i + 1][0];
        const p2t = polygon[i === polygon.length - 1 ? 0 : i + 1][1];
        const ming = Math.min(p1g, p2g);
        const maxg = Math.max(p1g, p2g);
        const mint = Math.min(p1t, p2t);
        const maxt = Math.max(p1t, p2t);
        if (
          mint <= t &&
          t <= maxt &&
          ming <= g &&
          (maxg <= g || p2g + (p1g - p2g) * ((t - p2t) / (p1t - p2t)) < g)
        ) {
          cnt++;
        }
      }
      return cnt % 2 === 1;
    },
    dialogVisible(name) {
      return this.currentDialog === name ? true : false;
    },
    handleDialogClose() {
      this.currentDialog = "";
    },
    getDateb(date) {
      let dateb;
      if (typeof date === "string") {
        dateb = date.match(
          new RegExp(
            "(\\d{4})-(\\d{2})-?(\\d{2})?\u0020?(\\d{2})?:?(\\d{2})?:?(\\d{2})?",
            "g"
          )
        );
        dateb = dateb ? dateb.join("").split("-").join("/") : "";
        date = date.split("-").join("/");
      }
      return dateb || date;
    },
    formatDate(date, sp) {
      let enddate = this.getDateb(date);
      let spStr = sp || ".";
      let dateYear = new Date(enddate).getFullYear();
      let dateMonth = (new Date(enddate).getMonth() + 1)
        .toString()
        .padStart(2, "0");
      let dateDate = new Date(enddate).getDate().toString().padStart(2, "0");
      return `${dateYear}${spStr}${dateMonth}${spStr}${dateDate}`;
    },
    routeLink() {
      location.href = "https://dezu.space/";
    },
  },
};
</script>

<!-- 引入template.html,style.scss  -->
<template src="./template.html"></template>
<style lang="scss" src="./style.scss"></style>
